let backBilling = {
  path: 'backBilling',
  name: 'backBilling',
  redirect: '/backBilling/index',
  component: () => import('@/views/backBilling/index.vue'),
  meta: {
    name: '团购下单'
  },
  children: [
    {
      path: 'index',
      name: 'backindex',
      component: () => import('@/views/backBilling/pages/index.vue'),
      meta: {
        name: '团购下单查询'
      }
    },
    {
      path: 'bill',
      name: 'backindexbill',
      component: () => import('@/views/backBilling/pages/bill.vue'),
      meta: {
        name: '查询结果'
      }
    }
  ]
}

export default backBilling;
